import React from "react";
import { SENTIMENT_BUCKET_DEFINITIONS } from "./greatSentimentReasons";

/**
 * Happy / Neutral / Unhappy column header with clickable bucket definition.
 * @param {{ bucketKey: 'positive' | 'neutral' | 'negative', label?: string, pillClass?: string }} props
 */
export default function SentimentBucketHeader({ bucketKey, label, pillClass = "" }) {
  const [open, setOpen] = React.useState(false);
  const rootRef = React.useRef(null);
  const def = SENTIMENT_BUCKET_DEFINITIONS[bucketKey];

  React.useEffect(() => {
    if (!open) return;
    const onDocClick = (event) => {
      const target = event?.target;
      if (!target || typeof target.closest !== "function") return;
      if (rootRef.current && !rootRef.current.contains(target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);
  const displayLabel = label || def?.title || bucketKey;

  return (
    <span ref={rootRef} className="relative inline-flex">
      <button
        type="button"
        className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold underline decoration-dotted underline-offset-2 hover:opacity-90 ${pillClass}`}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
        aria-expanded={open}
        title="What counts in this bucket?"
      >
        {displayLabel}
      </button>
      {open && def ? (
        <span
          role="tooltip"
          className="absolute left-0 top-full z-30 mt-1 w-72 rounded-md border border-gray-200 bg-white p-2 text-[11px] font-normal normal-case leading-snug text-gray-700 shadow-md dark:border-navy-600 dark:bg-navy-800 dark:text-gray-200"
        >
          {def.description}
        </span>
      ) : null}
    </span>
  );
}
